import * as constants from '../constants/actions';

const initialState = {
  leadsFilter: {},
  leadsResults: null,

  dropdownOpen: false,
  dropdownDiamonds: null,

  shareDirectDropdownOpen: false,
  shareDirectDropdownDiamonds: null,
  shareDirectDropdownType: 'DIAMOND',

  directory: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.LEADS_FILTER_SAVE:
      return saveLeadsFilters(state, action);
    case constants.LEADS_SAVE:
      return saveLeads(state, action);
    case constants.LEADS_OPEN_ADD_DROPDOWN:
      return openLeadsDropdown(state, action);
    case constants.LEADS_CLOSE_ADD_DROPDOWN:
      return closeLeadsDropdown(state, action);
    case constants.LEADS_OPEN_SHARE_DIRECT_DROPDOWN:
      return openShareDirectDropdown(state, action);
    case constants.LEADS_CLOSE_SHARE_DIRECT_DROPDOWN:
      return closeShareDirectDropdown(state, action);
    
      
      

    case constants.LEADS_SAVE_DIRECTORY:
      return saveLeadsDirectory(state, action);
    default:
      return state;
  }
}

function saveLeadsFilters(state, action) {
  return Object.assign({}, state, {
    leadsFilter: action.filters
  });
}

function saveLeads(state, action) {
  return Object.assign({}, state, {
    leadsResults: action.leads
  });
}

function saveLeadsDirectory(state, action) {
  return Object.assign({}, state, {
    directory: action.leads
  });
}

function openLeadsDropdown(state, action) {
  return Object.assign({}, state, {
    dropdownOpen: true,
    dropdownDiamonds: action.diamonds,
  });
}

function closeLeadsDropdown(state, action) {
  return Object.assign({}, state, {
    dropdownOpen: false,
    dropdownDiamonds: null,
  });
}

function openShareDirectDropdown(state, action) {
  return Object.assign({}, state, {
    shareDirectDropdownOpen: true,
    shareDirectDropdownDiamonds: action.diamonds,
    shareDirectDropdownType: action.mode,
  });
}

function closeShareDirectDropdown(state, action) {
  return Object.assign({}, state, {
    shareDirectDropdownOpen: false,
    shareDirectDropdownDiamonds: null,
    shareDirectDropdownType: 'DIAMOND',
  });
}

